import { Route, Routes, Navigate, useLocation } from 'react-router-dom';

import { ROUTE } from './RouteEnums';
import AuthLayout from 'components/AuthLayout';
import PageLayout from 'components/Layout';
import Profile from 'pages/Profile';
import SignOut from 'pages/SignOut';
import EmailVerified from 'pages/SignUp/EmailVerified';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import SignUp from 'pages/SignUp';
import MigratedSignUp from 'pages/SignUp/SignUp';
import SignIn from 'pages/SignIn';
import EmailVerification from 'pages/SignUp/EmailVerfication';
import Dashboard from 'pages/Dashboard';
import SuccessEmail from 'pages/ForgotPassword/SuccessEmail';
import SuccessPassword from 'pages/ResetPassword/SuccessPassword';
import Treatment from 'pages/Treatment';
import Documents from 'pages/Documents';
import MCAT from 'pages/M-CAT';
import MCATIntro from 'pages/M-CAT/intro';
import Advisory from 'pages/M-CAT/advisory';
import Navigation from 'pages/M-CAT/navigate';
import Assessment from 'pages/M-CAT/assessment';
import WellBeing from 'pages/Wellbeing';
import DiyPosts from 'pages/DiyPosts';
import AdminDashboard from 'pages/Admin/Dashboard';
import PatientInfo from 'pages/Admin/PatientInfo';
import { permissions } from 'utils/dropDownList';
import PermissionsProvider from 'components/PermissionsProvider';
import { InstallPWA } from 'components/PWA/InstallPWA';
import WellnessDashboard from 'pages/Profile/Wellness';
import MCATiDashboard from 'pages/Profile/MCAT-i';
import ChatboxAdmin from 'components/ChatboxAdmin';
import AppointmentDetails from 'pages/Admin/AppointmentDetails';
import SystemVitals from 'pages/SystemVitals';
import AdminProfile from 'pages/Admin/AdminProfile';
import TaskList from 'pages/Admin/Task';
import ConversationList from 'pages/Admin/Conversations';
import MCATResult from 'pages/Profile/MCATResult';
import AccountManagement from 'pages/Profile/AccountManagement';
import EmailPhoneNumber from 'pages/Profile/AccountManagement/EmailPhoneNumber';
import TransferAccountOwnership from 'pages/Profile/AccountManagement/TransferAccountOwnership';
import DeactivateAccount from 'pages/Profile/AccountManagement/DeactivateAccount';
import AccountManagementRequest from 'pages/Admin/AccountManagementRequest';
import UserManagement from 'pages/Admin/UserManagement';
import CreateUser from 'pages/Admin/UserManagement/createUser';
import OfficeList from 'pages/Admin/Office';
import PatientDatabaseReport from 'pages/Admin/MDAC/PatientDatabaseReport';
import PatientOnboarding from 'pages/Admin/MDAC/PatientOnboarding';
import WellnessChart from 'pages/Admin/PatientInfo/WellnessChart';
import IWiseScore from 'pages/Admin/PatientInfo/IWiseScore';
import PatientJobsTable from 'pages/Admin/MDAC/PatientJobsTable';
import RatingsDashboard from 'pages/Admin/Missllenious/RatingDashboard';
import SourceDashboard from 'pages/Admin/Missllenious/SourceDashboard';
import ApplicationHealthDashboard from 'pages/Admin/MDAC/ApplicationHealthDashboard';
import AppointmentCalendar from 'pages/Admin/AppointmentCalendar';
import NextPatientADHDWidget from 'pages/Admin/NextPatientADHDWidget';
import UserOfficeList from 'pages/Admin/UserManagement/UserOfficeList';
import RoleDetail from 'pages/Admin/RoleManagement/RoleDetail';
import ManageRoles from 'pages/Admin/RoleManagement';
import SyncCalendar from 'pages/Admin/SyncCalendar';
import SyncJobs from 'pages/Admin/SyncJobs';
import Account from 'pages/Profile/LeftMenu/Account';
import AccountManagementHome from 'pages/Profile/LeftMenu/AccountManagementHome';
import Billing from 'pages/Profile/LeftMenu/Billing';
import Care from 'pages/Profile/LeftMenu/Care';
import MFSHAssessment from 'pages/MFSH/MFSHAssessment';
import MFSHNavigate from 'pages/MFSH/NavigateMFSH';
import DocumentsReview from 'pages/Admin/Documents';
import PolicyConsent from 'pages/PolicyConsent';
import SelfScheduling from 'pages/SelfScheduling';
import ProviderAvailability from 'pages/SelfScheduling/ProviderAvailability';
import ManageAppointment from 'pages/ManageAppointment';

const OnboardingRouter = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path={ROUTE.INSTALL} element={<InstallPWA />} />
      <Route element={<PageLayout />}>
        <Route path={ROUTE.FORGOTPASSWORD} element={<ForgotPassword />} />
        <Route path={ROUTE.RESETPASSWORD} element={<ResetPassword />} />
        <Route path={ROUTE.LOGIN} element={<SignIn />} index />
      </Route>
      <Route path={ROUTE.SIGNUP} element={<SignUp />} />
      <Route path={ROUTE.MIGRATION_SIGNUP} element={<MigratedSignUp />} />
      <Route path={ROUTE.TRANSFER_SIGNUP} element={<MigratedSignUp />} />
      <Route path={ROUTE.VALIDATE_USER} element={<EmailVerified />} />
      <Route path={ROUTE.EMAILVERIFICATION} element={<EmailVerification />} />
      <Route path={ROUTE.SUCCESSEMAIL} element={<SuccessEmail />} />
      <Route path={ROUTE.SUCCESSPASSWORD} element={<SuccessPassword />} />

      <Route path={ROUTE.SIGN_OUT} element={<SignOut />} />

      {/* protected  routes after login... */}
      <Route element={<AuthLayout />}>
        {/* Added edit profile permission which is only for patient so admin can not visit this route */}
        <Route element={<PermissionsProvider permissions={[permissions.EDIT_PROFILE]} />}>
          <Route path={ROUTE.DASHBOARD} element={<Dashboard />} />
        </Route>
        <Route element={<PermissionsProvider permissions={[permissions.EDIT_PROFILE]} />}>
          <Route path={ROUTE.TREATMENT} element={<Treatment />} />
        </Route>
        {/* Added document permission related to document  */}
        <Route element={<PermissionsProvider permissions={[permissions.VIEW_DOCUMENTS]} />}>
          <Route path={ROUTE.DOCUMENTS} element={<Documents />} />
        </Route>
        <Route path={`${ROUTE.ADMIN_DOCUMENT_REVIEW}`} element={<DocumentsReview />} />
        {/* MM-1131: Account Management tiles page (requests, Family & Friends Authorization, Care Contact) */}
        <Route path={ROUTE.PROFILE_ACCOUNT} element={<AccountManagementHome />} />
        <Route path={ROUTE.PROFILE_SETTINGS} element={<Account />} />
        <Route path={ROUTE.PROFILE_CARE} element={<Care />} />
        <Route path={ROUTE.PROFILE_BILLING} element={<Billing />} />
        <Route path={ROUTE.SELF_SCHEDULING} element={<SelfScheduling />} />
        <Route path={ROUTE.SELF_SCHEDULING_PROVIDER} element={<ProviderAvailability />} />
        <Route path={ROUTE.MANAGE_APPOINTMENT} element={<ManageAppointment />} />
        {/* Added multiple permission related to profile  */}
        <Route element={<PermissionsProvider permissions={[permissions.EDIT_PROFILE]} />}>
          <Route path={ROUTE.PROFILE}>
            <Route index element={<Profile for='patientInfo' from='guardian' />} />
            <Route path={ROUTE.PATIENT_INFORMATION} element={<Profile for='patientInfo' from='guardian' />} />
            <Route path={ROUTE.GUARDIAN_INFORMATION} element={<Profile for='guardianInfo' from='guardian' />} />
            <Route path={ROUTE.PROVIDER_INFORMATION} element={<Profile for='providerInfo' from='guardian' />} />
            <Route path={ROUTE.COUNSELOR_INFORMATION} element={<Profile for='counselorInfo' from='guardian' />} />
            <Route path={ROUTE.PHARMACY_DETAILS} element={<Profile for='pharmacyDetails' from='guardian' />} />
            <Route path={ROUTE.INSURANCE_DETAILS} element={<Profile for='insuranceDetails' from='guardian' />} />
            <Route path={ROUTE.WELLNESS_DASHBOARD} element={<WellnessDashboard />} />
            <Route path={ROUTE.MCAT_DASHBOARD} element={<MCATiDashboard from='guardian' />} />
            <Route path={ROUTE.MCAT_RESULT} element={<MCATResult />} />
            <Route path={ROUTE.ACCOUNT_MANAGEMENT}>
              <Route index element={<AccountManagement />} />
              <Route path={ROUTE.UPDATE_EMAIL_PHONE} element={<EmailPhoneNumber from='guardian' />} />
              <Route path={ROUTE.TRANSFER_ACCOUNT_OWNERSHIP} element={<TransferAccountOwnership from='guardian' />} />
              <Route path={ROUTE.DEACTIVATE_ACCOUNT} element={<DeactivateAccount from='guardian' />} />
            </Route>
          </Route>
        </Route>
        {/* <Route path={ROUTE.HELP} element={<Help />} /> */}
        {/* Added multiple permission related to dashboard widgets  */}
        <Route
          element={
            <PermissionsProvider
              permissions={[
                permissions.TAKE_MCAT,
                permissions.TAKE_MFSH,
                permissions.TAKE_WELLBEING,
                permissions.VIEW_EHR_DETAILS,
              ]}
            />
          }
        >
          <Route path={ROUTE.DASHBOARD} element={<Dashboard />} />
        </Route>
        <Route element={<PermissionsProvider permissions={[permissions.VIEW_DOCUMENTS]} />}>
          <Route path={ROUTE.DOCUMENTS} element={<Documents key={location.key} />} />
        </Route>
        <Route element={<PermissionsProvider permissions={[permissions.EDIT_PROFILE]} />}>
          <Route path={ROUTE.OPEN_POLICY_DOCUMENTS} element={<PolicyConsent />} />
        </Route>
        <Route element={<PermissionsProvider permissions={[permissions.TAKE_MCAT]} />}>
          <Route path={ROUTE.MCAT_TEST} element={<MCAT />} />
          <Route path={ROUTE.MCAT_INTRO} element={<MCATIntro />} />
          <Route path={ROUTE.MCAT_ADVISORY} element={<Advisory />} />
          <Route path={ROUTE.MCAT_NAVIGATE} element={<Navigation />} />

          <Route path={ROUTE.MCAT_ASSESSMENT} element={<Assessment />} />
        </Route>
        <Route element={<PermissionsProvider permissions={[permissions.TAKE_MFSH]} />}>
          <Route path={ROUTE.MFSH_NAVIGATE} element={<MFSHNavigate />} />
          <Route path={ROUTE.MFSH_ASSESSMENT} element={<MFSHAssessment />} />
        </Route>
        {/* WellBeing */}
        <Route element={<PermissionsProvider permissions={[permissions.TAKE_WELLBEING]} />}>
          <Route path={ROUTE.WELLBEING} element={<WellBeing />} />
          <Route path={ROUTE.WELLBEING_ASSESSMENT} element={<Assessment />} />
        </Route>
        <Route path={ROUTE.DIY_POSTS} element={<DiyPosts />} />
        {/* <Route path={ROUTE.FAQ} element={<Faq />} /> */}
        {/* Added view patients list permission which is used only for admin  */}
        <Route element={<PermissionsProvider permissions={[permissions.VIEW_PATIENTS]} />}>
          <Route path={ROUTE.ADMIN_DASHBOARD} element={<AdminDashboard />} />
        </Route>
        {/* Added multiple permission in case have some of them allocated other will restricted at component level */}
        <Route
          element={
            <PermissionsProvider
              permissions={[
                permissions.UPDATE_MCAT_SCORE,
                permissions.DOWNLOAD_MCAT,
                permissions.DOWNLOAD_MFSH,
                permissions.DOWNLOAD_WELLBEING,
                permissions.CREATE_APPOINTMENT,
                permissions.SAVE_EHR_DETAILS,
                permissions.SEND_REMINDERS,
                permissions.SAVE_APPOINTMENT_DATA,
                permissions.CREATE_PATIENT,
              ]}
            />
          }
        >
          <Route path={`${ROUTE.ADMIN_PATIENT_INFO}/:id`} element={<PatientInfo from='admin' />} />
          <Route path={`${ROUTE.ADMIN_APPOINTMENTS_CALENDER_ADHD}`} element={<NextPatientADHDWidget />} />
          <Route path={`${ROUTE.ADMIN_APPOINTMENTS}`} element={<AppointmentCalendar from='admin' />} />
          <Route path={`${ROUTE.ADMIN_MESSAGES}`} element={<ChatboxAdmin from='admin' />} />
          <Route path={`${ROUTE.ADMIN_TASKLIST}`} element={<TaskList />} />
          <Route path={`${ROUTE.ADMIN_PATIENT_REPORT}`} element={<PatientDatabaseReport />} />
          <Route path={`${ROUTE.ADMIN_PATIENT_ONBOARDING}`} element={<PatientOnboarding />} />
          <Route path={`${ROUTE.ADMIN_OFFICE_LIST}`} element={<OfficeList />} />
          <Route path={`${ROUTE.ADMIN_PRACTICE_APPOINTMENT_PROFILE_MAPPING}`} element={<UserOfficeList />} />
          <Route path={`${ROUTE.ADMIN_CONVERSATION_LIST}`} element={<ConversationList />} />
          <Route path={`${ROUTE.ADMIN_ACCOUNT_MANAGEMENT_REQUEST}`} element={<AccountManagementRequest />} />
          <Route path={`${ROUTE.ADMIN_JOBS_REPORT}`} element={<PatientJobsTable />} />
          <Route path={`${ROUTE.APPLICATION_HEALTH}`} element={<ApplicationHealthDashboard />} />
          <Route path={`${ROUTE.ADMIN_MDAC_FEEDBACK_RATING}`} element={<RatingsDashboard />} />
          <Route path={`${ROUTE.ADMIN_MDAC_SOURCE_DASHBOARD}`} element={<SourceDashboard />} />
          <Route path={ROUTE.ADMIN_UPDATE_EMAIL_PHONE} element={<EmailPhoneNumber from='admin' />} />
          <Route path={ROUTE.ADMIN_TRANSFER_ACCOUNT_OWNERSHIP} element={<TransferAccountOwnership from='admin' />} />
          <Route path={ROUTE.ADMIN_DEACTIVATE_ACCOUNT} element={<DeactivateAccount from='admin' />} />
          <Route path={ROUTE.ADMIN_PRACTICE_MANAGE_USERS_LIST} element={<UserManagement />} />
          <Route path={ROUTE.ADMIN_USER_CREATE} element={<CreateUser />} />
          <Route path={`${ROUTE.ADMIN_USER_CREATE}/:id`} element={<CreateUser />} />
        </Route>
        <Route path={`${ROUTE.ADMIN_APPOINTMENT_DETAILS}/:id`} element={<AppointmentDetails />} />
        <Route path={`${ROUTE.ADMIN_PROFILE}`} element={<AdminProfile />} />
        {/* Added only one permission which is used for admin only so patient can not visit these routes */}
        <Route element={<PermissionsProvider permissions={[permissions.CREATE_PATIENT]} />}>
          <Route path={ROUTE.ADMIN_PATIENT_PROFILE}>
            <Route index element={<Profile for='patientInfo' from='admin' />} />
            <Route path={ROUTE.ADMIN_PATIENT_INFORMATION} element={<Profile for='patientInfo' from='admin' />} />
            <Route path={ROUTE.ADMIN_GUARDIAN_INFORMATION} element={<Profile for='guardianInfo' from='admin' />} />
            <Route path={ROUTE.ADMIN_PROVIDER_INFORMATION} element={<Profile for='providerInfo' from='admin' />} />
            <Route path={ROUTE.ADMIN_COUNSELOR_INFORMATION} element={<Profile for='counselorInfo' from='admin' />} />
            <Route path={ROUTE.ADMIN_PHARMACY_DETAILS} element={<Profile for='pharmacyDetails' from='admin' />} />
            <Route path={ROUTE.ADMIN_INSURANCE_DETAILS} element={<Profile for='insuranceDetails' from='admin' />} />
          </Route>
          <Route path={ROUTE.ADMIN_PRACTICE_MANAGE_ROLES_AND_PERMISSIONS} element={<ManageRoles />} />
          <Route path={ROUTE.ADMIN_PRACTICE_MANAGE_ROLES_AND_PERMISSIONS + '/:id'} element={<RoleDetail />} />
        </Route>
        {/* MM-1168: same staff-only permission ehr-sync's calendar-sync endpoints require */}
        <Route element={<PermissionsProvider permissions={[permissions.VIEW_EHR_DETAILS]} />}>
          <Route path={ROUTE.ADMIN_PRACTICE_SYNC_CALENDAR} element={<SyncCalendar />} />
          {/* MM-1169: reads the same calendar-sync endpoint */}
          <Route path={ROUTE.ADMIN_SYNC_JOBS} element={<SyncJobs />} />
        </Route>
        <Route path='*' element={<Navigate to={ROUTE.DASHBOARD} replace />} />
        <Route path={ROUTE.SYSTEM_VITALS} element={<SystemVitals />} />
      </Route>

      {/* not part of a app */}
      {/* <Route path={ROUTE.THEME} element={<ThemePage />} /> */}
      <Route path='*' element={<Navigate to={ROUTE.SIGN_OUT} replace />} />
      <Route path={`${ROUTE.WELLNESS_ADMIN_DASHBOARD}/:patientId`} element={<WellnessChart />} />
      <Route path={`${ROUTE.IWISE_ADMIN_DASHBOARD}/:patientId`} element={<IWiseScore />} />
    </Routes>
  );
};

export default OnboardingRouter;
